// app/components/form-sections/CounselorContactSection.jsx
"use client";
import { useState } from "react";
import Field from "../ui/Field";
import { HistoryDatalist } from "../ui/HistoryDatalist";

const FIELDS = [
  ["Counselor Name", "counselor_name", "e.g., Casey Rivera"],
  ["Title", "counselor_title", "e.g., High School Counselor"],
  ["School", "school", "e.g., North Ridge High School"],
  ["Email", "email", "e.g., counselor@school.edu"],
  ["Phone", "phone", "e.g., (555) 222-8899"],
  ["Address line 1", "address1", "e.g., 123 School Ln."],
  ["Address line 2", "address2", "e.g., Springfield, CA 90000"],
];

export default function CounselorContactSection({ form, setField, pushHistory, history }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="rounded-2xl border border-gray-200 bg-white mt-6">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="w-full flex items-center justify-between px-4 py-3 sm:px-5 border-b border-gray-200 hover:bg-slate-100"
        aria-expanded={open}
        aria-controls="counselor-contact-panel"
      >
        <span className="text-[13px] sm:text-sm font-semibold text-slate-900">Counselor Contact</span>
        <span className="inline-flex items-center gap-2 text-sm text-gray-700">
          {open ? "Hide" : "Show"}
          <svg className={`h-5 w-5 transition-transform ${open ? "rotate-180" : ""}`} viewBox="0 0 20 20" fill="currentColor" aria-hidden>
            <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 10.94l3.71-3.71a.75.75 0 1 1 1.06 1.06l-4.24 4.24a.75.75 0 0 1-1.06 0L5.21 8.29a.75.75 0 0 1 .02-1.08z" clipRule="evenodd" />
          </svg>
        </span>
      </button>

      {open && (
        <div id="counselor-contact-panel" className="p-4 sm:p-5 grid gap-4">
          <div className="grid gap-4 sm:grid-cols-2">
            {FIELDS.map(([label, key, ph]) => (
              <Field key={key} label={label}>
                <input
                  placeholder={ph}
                  className="w-full rounded-xl border border-gray-200 bg-white px-3 py-2.5 shadow-sm outline-none focus:border-teal-600 focus:ring-2 focus:ring-teal-600/40 hover:bg-slate-100"
                  value={form[key]}
                  onChange={setField(key)}
                  onBlur={(e) => pushHistory(key, e.target.value)}
                  list={`hist-${key}`}
                />
                <HistoryDatalist id={`hist-${key}`} values={history[key] || []} />
              </Field>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
